import onceVisible from "@core/scripts/helper/once-visible.js";

export default function (element, data, sendTrinityEvent) {
  // Only send landmark if element is in view port
  onceVisible(element, () => {
    sendTrinityEvent(data);
  });
}
